/* Lager-bevidst resultat: skjuler udsolgte farver for valgt stoerrelse og skifter den valgte/anbefalede farve til naermeste paa lager. Kaldes af wrapRender-hook (window.nwAvailPass). */
(function(){
  var AV={},LOADING={},switching=false;
  function norm(s){return String(s||'').toLowerCase().replace(/×/g,'x').replace(/\s+/g,'').replace(/cm/g,'');}
  function cols(mat){return (typeof materials!=='undefined'&&materials[mat]&&materials[mat].colors)||[];}
  function variantForSize(p,want){if(!p||!p.variants)return null;var i,j;for(i=0;i<p.variants.length;i++){var v=p.variants[i],o=v.options||[];for(j=0;j<o.length;j++){if(norm(o[j])===want)return v;}}for(i=0;i<p.variants.length;i++){if(norm(p.variants[i].title).indexOf(want)===0)return p.variants[i];}if(p.variants.length===1)return p.variants[0];return null;}
  function fetchP(h){return fetch('/products/'+h+'.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).catch(function(){return null;});}
  function load(mat,sizeRaw){
    try{
      var sN=norm(sizeRaw),lk=mat+'|'+sN,cs=cols(mat),need=[],i;
      if(LOADING[lk])return;
      for(i=0;i<cs.length;i++){if(AV[mat+'|'+i+'|'+sN]===undefined)need.push(i);}
      if(!need.length)return;
      LOADING[lk]=true;
      var done=0;
      need.forEach(function(ci){
        fetchP(cs[ci].handle).then(function(p){
          if(!p){AV[mat+'|'+ci+'|'+sN]=true;return;}
          var v=variantForSize(p,sN);
          AV[mat+'|'+ci+'|'+sN]=!!(v&&v.available!==false);
        },function(){AV[mat+'|'+ci+'|'+sN]=true;}).then(function(){
          done++;if(done===need.length){LOADING[lk]=false;if(window.nwAvailPass)window.nwAvailPass();}
        });
      });
    }catch(e){}
  }
  function nearest(mat,sN,from){
    var cs=cols(mat),fromTone=(cs[from]||{}).tone;
    var pref=({warm:['warm','light','green','deep'],light:['light','warm','green','deep'],green:['green','warm','light','deep'],deep:['deep','green','warm','light']})[fromTone]||['warm','light','green','deep'];
    var order=[],k;for(k=0;k<cs.length;k++){if(k!==from)order.push(k);}
    order.sort(function(x,y){var tx=pref.indexOf(cs[x].tone);var ty=pref.indexOf(cs[y].tone);if(tx<0)tx=9;if(ty<0)ty=9;return tx!==ty?tx-ty:x-y;});
    for(k=0;k<order.length;k++){if(AV[mat+'|'+order[k]+'|'+sN]===true)return order[k];}
    return -1;
  }
  function apply(){
    try{
      if(typeof chosen==='undefined'||!chosen.mat)return;
      var mat=chosen.mat,sN=norm(chosen.size),host=document.getElementById('swatches');
      if(!host)return;
      var sws=host.querySelectorAll('.sw'),i;
      for(i=0;i<sws.length;i++){var el=sws[i],idx=+el.getAttribute('data-i'),av=AV[mat+'|'+idx+'|'+sN];el.style.display=(av===false&&idx!==chosen.color)?'none':'';}
    }catch(e){}
  }
  window.nwAvailWarm=function(mat,size){try{if(mat&&size)load(mat,size);}catch(e){}};
  window.nwAvailPass=function(){
    try{
      if(switching)return;
      if(typeof chosen==='undefined'||!chosen.mat||!chosen.size)return;
      var mat=chosen.mat,sN=norm(chosen.size),cs=cols(mat),i;
      if(AV[mat+'|'+chosen.color+'|'+sN]===false){
        var pick=nearest(mat,sN,chosen.color);
        if(pick>=0){
          switching=true;
          chosen.color=pick;chosen.rec=pick;chosen.hero=0;
          try{var cn=cs[pick].name,ct=cs[pick].tone;chosen.lagen.ci=matchColor(lagenColors,cn,ct);chosen.pb.ci=matchColor(pudeColors,cn,ct);}catch(e2){}
          if(typeof renderResult==='function')renderResult();
          switching=false;
          return;
        }
      }
      apply();
      var unknown=false;for(i=0;i<cs.length;i++){if(AV[mat+'|'+i+'|'+sN]===undefined){unknown=true;break;}}
      if(unknown)load(mat,chosen.size);
    }catch(e){}
  };
})();
